import '@fortawesome/fontawesome-free/css/all.min.css'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'fa',
  },
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#22DB75',
        primaryGradient: '#BBE95C',
        secondary: '#4C9DFF',
        secondaryGradient: '#9C91FF',
        text: '#000000',
        lightText: colors.grey.lighten1,
        lighter: '#ECEEF5',
        accent: '#F5F7FA',
        fill: '#FFFFFF',
        darkFill: '#1F2836',
        success: '#4CAF50',
        warning: '#FF8008',
        warningGradient: '#FFC837',
        error: '#f85032',
        errorGradient: '#e73827',
      },
    },
    options: {
      customProperties: true,
    },
  },
})
